import React from 'react';
import moment from 'moment';

export const DateFormat = React.memo(({date, format = 'MM/DD/YY'}) => (
  <>
    {moment(date)
      .utc()
      .format(format)}
  </>
));

export const TimeFormat = React.memo(({date, format = 'MM/DD/YY h:mm A'}) => (
  <>
    {moment(date)
      .utc()
      .local()
      .format(format)}
  </>
));
